import { observer } from 'mobx-react/index'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { withTranslation } from '../../i18n'
import Button from '../Button'
import ArtistRoundPreview from '../HeadlinersRoundPreview'
import { Container } from './styles'

const previewGap = 23
const previewGapPhone = 19

@observer
class HeadlinersRoundGrid extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    headliners: PropTypes.arrayOf(Object).isRequired,
    activeYear: PropTypes.number.isRequired
  };

  render() {
    const { headliners, activeYear, t } = this.props

    return (
      <Container previewGap={previewGap} previewGapPhone={previewGapPhone}>
        <h1 className="header">{`${t('headliners')} ${activeYear}`}</h1>
        <div className="previews">
          {headliners.map(headliner => (
            <ArtistRoundPreview
              key={headliner.id}
              artist={headliner}
              previewGap={previewGap}
              previewGapPhone={previewGapPhone}
            />
          ))}
        </div>
        <Button
          notScale
          className="btn"
          href={`/history/${activeYear}/artists`}
        >
          {t('about:all_artists')}
        </Button>
      </Container>
    )
  }
}

export default withTranslation(['common', 'about'])(HeadlinersRoundGrid)
